import { tv } from 'tailwind-variants';

const StarRatingStyles = tv({
    slots: {
        container: `
      iris:relative
      iris:flex
      iris:items-center
      iris:select-none
    `,
        star: "iris:fill-(--comp-color-content-star-rating-icon)",
    },
    variants: {
        size: {
            sm: {
                star: `
        iris:h-(--comp-size-box-star-rating-abbr-sm)
        iris:w-(--comp-size-box-star-rating-abbr-sm)
        `,
            },
            md: {
                star: `
        iris:h-(--comp-size-box-star-rating-abbr-md)
        iris:w-(--comp-size-box-star-rating-abbr-md)
        `,
            },
            lg: {
                star: `
        iris:h-(--comp-size-box-star-rating-abbr-lg)
        iris:w-(--comp-size-box-star-rating-abbr-lg)
        `,
            },
            xl: {
                star: `
        iris:h-(--comp-size-box-star-rating-abbr-xl)
        iris:w-(--comp-size-box-star-rating-abbr-xl)
        `,
            },
        },
        inverse: {
            true: {
                star: "iris:fill-(--comp-color-content-star-rating-icon-inverse)",
            },
        },
    },
});

export { StarRatingStyles as default };
